import feather from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import io from 'socket.io-client'
import auth from '@feathersjs/authentication-client'
import {canAccessAdmin, getSignedInUser, signOut} from './utility'
import {ErrorCode} from './http-utils'

const socket = io(process.env.REACT_APP_BACKEND_URL, {
  transports: ['websocket']
})

const feathers = feather()

feathers.configure(socketio(socket))

feathers.configure(
  auth({
    storage: window.localStorage,
    storageKey: process.env.REACT_APP_AUTH_STORAGE_KEY
  })
)

feathers.hooks({
  error(context) {
    console.error(`Error in '${context.path}' service method '${context.method}'`, context)
    const token = window.localStorage.getItem(process.env.REACT_APP_AUTH_STORAGE_KEY)
    if (context.error.code === ErrorCode.AuthenticationError && token) {
      console.log('redirecting from here')
      signOut()
    }
  }
})

const onUserRemoved = data => {
  const user = getSignedInUser()
  if (user._id === data._id) {
    signOut()
  }
}

const onUserPatched = data => {
  const user = getSignedInUser()
  if (user._id === data._id) {
    if (!canAccessAdmin()) {
      signOut()
    }
  }
}

feathers.service('user').on('patched', onUserPatched)
feathers.service('user').on('removed', onUserRemoved)

export default feathers
